export default __webpack_public_path__ + "static/media/5.43e79775.png";